import { render, staticRenderFns } from "./MajorForm.vue?vue&type=template&id=38075081&scoped=true"
import script from "./MajorForm.vue?vue&type=script&lang=js"
export * from "./MajorForm.vue?vue&type=script&lang=js"
import style0 from "./MajorForm.vue?vue&type=style&index=0&id=38075081&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38075081",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
